export enum FrameworkUserRole {
    ANONYMOUS = 'anonymous', // Not logger in user session has this role
    USER = 'user', // Every logged-in user has this role
    ADMIN = 'admin', // Administrator
    NODE = 'node', // Application user
}
